export interface LifePreset {
  readonly id: string;
  readonly name: string;
  readonly credit: string;
  readonly year: number | string;
  readonly description: string;
  readonly rle: string;
  readonly stepsPerSecond: number;
}

export const FEATURED_PRESETS: readonly LifePreset[] = [
  {
    id: "r-pentomino",
    name: "R-pentomino",
    credit: "John Conway",
    year: 1969,
    description: "A five-cell methuselah that takes 1,103 generations to stabilize.",
    rle: `x = 3, y = 3, rule = B3/S23
b2o$2o$bo!`,
    stepsPerSecond: 10,
  },
  {
    id: "pulsar",
    name: "Pulsar",
    credit: "John Conway",
    year: 1970,
    description: "The first known and most common period-3 oscillator.",
    rle: `x = 13, y = 13, rule = B3/S23
2b3o3b3o2b2$o4bobo4bo$o4bobo4bo$o4bobo4bo$2b3o3b3o2b2$2b3o3b3o2b$o4bobo4bo$o4bobo4bo$o4bobo4bo2$2b3o3b3o!`,
    stepsPerSecond: 3,
  },
  {
    id: "gosper-glider-gun",
    name: "Gosper glider gun",
    credit: "Bill Gosper",
    year: 1970,
    description: "The first finite pattern known to exhibit unbounded growth.",
    rle: `x = 36, y = 9, rule = B3/S23
24bo11b$22bobo11b$12b2o6b2o12b2o$11bo3bo4b2o12b2o$2o8bo5bo3b2o$2o8bo3bob2o4bobo$10bo5bo7bo$11bo3bo$12b2o!`,
    stepsPerSecond: 12,
  },
  {
    id: "new-gun-1",
    name: "New gun 1",
    credit: "Bill Gosper",
    year: 1971,
    description: "The second glider gun to be discovered.",
    rle: `x = 36, y = 34, rule = B3/S23
25b2o5b2o$25b2o5b2o8$26bo5bo$25b3o3b3o$24b2obo3bob2o3$27bo3bo$27bo3bo7$33bo$10b2o22b2o$2o7bobo21b2o$2o7bo$9b3o4$9b3o$2o7bo17b2o$2o7bobo15b2o$10b2o!`,
    stepsPerSecond: 12,
  },
  {
    id: "simkin-glider-gun",
    name: "Simkin glider gun",
    credit: "Michael Simkin",
    year: 2015,
    description: "The smallest known glider gun by cell count.",
    rle: `x = 33, y = 14, rule = B3/S23
2o5b2o$2o5b2o2$4b2o$4b2o5$22bo3bo$21bo4b2o$20b2o5b2o2b2o$21b2o4bo3b2o$22bo!`,
    stepsPerSecond: 15,
  },
  {
    id: "puffer-1",
    name: "Puffer 1",
    credit: "Bill Gosper",
    year: 1971,
    description: "The first known puffer.",
    rle: `x = 27, y = 7, rule = B3/S23
b3o6bo5bo6b3o$o2bo5b3o3b3o5bo2bo$3bo4b2obo3bob2o4bo$3bo19bo$3bo2bo13bo2bo$3bo2b2o11b2o2bo$2bo3b2o11b2o3bo!`,
    stepsPerSecond: 12,
  },
  {
    id: "puffer-2",
    name: "Puffer 2",
    credit: "Bill Gosper",
    year: 1971,
    description: "The second known puffer; its chaotic tail takes 5,533 generations to stabilize.",
    rle: `x = 18, y = 5, rule = B3/S23
b3o11b3o$o2bo10bo2bo$3bo4b3o6bo$3bo4bo2bo5bo$2bo4bo8bo!`,
    stepsPerSecond: 12,
  },
  {
    id: "block-laying-switch-engine",
    name: "Block-laying switch engine",
    credit: "Charles Corderman",
    year: 1971,
    description: "The most common naturally occurring pattern that exhibits infinite growth.",
    rle: `x = 29, y = 28, rule = B3/S23
18bo$3o8bo5bo$o3bo6bo7bo$b2o9b4o2b2o$3b2ob2o9b3o$5b2o11bobo$19bo7b2o$19bo7b2o11$7b2o$7b2o7$15b2o$15b2o!`,
    stepsPerSecond: 12,
  },
  {
    id: "space-rake",
    name: "Space rake",
    credit: "Unknown",
    year: "≤1971",
    description: "The first known rake; it emits a glider every 20 generations.",
    rle: `x = 22, y = 19, rule = B3/S23
11b2o5b4o$9b2ob2o3bo3bo$9b4o8bo$10b2o5bo2bo2$8bo$7b2o8b2o$6bo9bo2bo$7b5o4bo2bo$8b4o3b2ob2o$11bo4$18b4o$o2bo13bo3bo$4bo16bo$o3bo12bo2bo$b4o!`,
    stepsPerSecond: 12,
  },
];
